export const FIELD_REQUIRED = "is required";
export const FIELD_LENGTH = "exceeds the maximum character length";
export const FIELD_IN_USE = "already in use";
